
<div class="parent fx-row">
  <div class="left">
    <about-company></about-company>
  </div>
  <div class="right">
    <section>
      <form [formGroup]="setPasswordForm">
        <mat-card>
          <h2>
            Set Password
          </h2>
          <mat-card-content>
            <mat-form-field appearance="fill" subscriptSizing="dynamic" hideRequiredMarker>
              <mat-label>Enter verfication code</mat-label>
              <input class="resetPassword-email-input" matInput formControlName="verficationCode" placeholder="Enter your verfication code" autocomplete="off" minlength="6"  maxlength="6" required>
              @if (verificationCode.touched && verificationCode.hasError('required') && verificationCode.invalid) {
                <mat-error>Verfication Code is required</mat-error>
              }
              @if (verificationCode.touched && verificationCode.hasError('minlength')) {
                <mat-error>Six character verfication code required</mat-error>
              }
            </mat-form-field>
            <mat-form-field appearance="fill" subscriptSizing="dynamic" hideRequiredMarker>
              <mat-label>Enter password</mat-label>
              <input [type]="hide ? 'password' : 'text'" class="resetPassword-email-input" matInput formControlName="newPassword" placeholder="Enter password" autocomplete="off" minlength="4" maxlength="15" required>
              @if (newPassword.touched && newPassword.hasError('required') && newPassword.invalid) {
                <mat-error>Password field is required</mat-error>
              }
              @if (newPassword.touched && newPassword.hasError('minlength')) {
                <mat-error>Minimum 4 character are required</mat-error>
              }
              <mat-icon class="__show_psw" matSuffix (click)="hide = !hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
            </mat-form-field>
            <mat-form-field appearance="fill" subscriptSizing="dynamic" hideRequiredMarker>
              <mat-label>Enter confirm password</mat-label>
              <input [type]="oldHide ? 'password' : 'text'" class="resetPassword-email-input" matInput formControlName="oldPassword" placeholder="Enter confirm password" autocomplete="off" minlength="4" maxlength="15" required>
              @if (confirmPassword.touched && confirmPassword.hasError('required') && confirmPassword.invalid) {
                <mat-error>confirm password field is required</mat-error>
              }
              @if (confirmPassword.touched && confirmPassword.hasError('minlength')) {
                <mat-error>Minimum 4 character are required</mat-error>
              }
              @if (confirmPassword.touched && confirmPassword.hasError('mustMatch')) {
                <mat-error>password doesn't matched</mat-error>
              }
              <mat-icon class="__show_psw" matSuffix (click)="oldHide = !oldHide">{{oldHide ? 'visibility_off' : 'visibility'}}</mat-icon>
            </mat-form-field>
          </mat-card-content>
          <mat-card-actions>
            <button mat-button color="cancel" (click)="onCancel()">CANCEL</button>
            <button mat-button color="primary" (click)="onSave()">SUBMIT</button>
          </mat-card-actions>
        </mat-card>
      </form>
    </section>
  </div>
</div>